import Vue from 'vue';
import { GlobalState } from '../global-state/global-state';
import { AddToSamplesButton } from './product-samples/add-to-samples-button-component';
import ProductSamplesClass from '../components/product-samples/product-samples';

export default () => {
  const promoBanner = document.querySelectorAll('.promo-banner-lg');
  if (!promoBanner) {
    return;
  }
  promoBanner.forEach((element) => {
    const elementID = element.getAttribute('id');
    const enable_samples_cta = element.querySelector(
      '[js-contains-sample-cta]'
    );
    if (enable_samples_cta) {
      new Vue({
        el: `#${elementID}`,
        components: {
          'add-to-samples': AddToSamplesButton,
        },
        data: {
          sharedState: GlobalState.state,
          productSampleClass: null,
        },
        beforeMount() {
          this.productSampleClass = new ProductSamplesClass(this);
        },
        mounted() {},
        methods: {
          ctaButtonIsEnabled(event) {
            // This method needs to be here to prevent Vue js throwing an error from the 'cta-button' snippet
          },
        },
      });
    }
  });
};
